import { AxiosError } from "axios";

import i18n from "@/modules/i18n";
import Api from "@/modules/axios";

interface LigneDeListe {

}

// ---------------------------- ICI c'est le No Man's Land ----------------------------
const acceptedCodes = [
  1, // Disponible
  2, // A paraitre
  3, // En cours de réimpression
  4, // Non disponible provisoirement
  8, // A reparaitre
  97, // Disponible jusqu'à épuisement des stocks
];
export interface Offre {
  id: number;
  code_disponibilite: number;
}

export interface AddLigneApiResponse {
  data: {
    already_in_list: boolean;
  }
}
// -----------------------------------------------------------------------------------

export default class Liste {
  id!: number;
  libelle!: string;
  lignes!: [LigneDeListe];

  constructor(data: Params<Liste>) {
    Object.assign(this, data);
  }

  /**
   * Éxécute l'appel API pour ajouter un article à la liste
   * @param offre - L'offre à ajouter
   * @param quantite - La quantité à ajouter
   * @returns - La promesse de l'appel API
   */
  protected _ajouterArticle(offre: Offre, quantite: number) {
    return Api().post(
      `/liste/${this.id}/add_lignes/`,
      {
        lignes: [{ id_offre: offre.id, quantite }],
      },
    ).then((res: AddLigneApiResponse) => ({
      success: true,
      state: res.data.already_in_list ? "already_in_list" : "added",
    })).catch((error: AxiosError) => {
      const data = error.response?.data;
      return {
        success: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        message: (typeof data === "object" && (data as any)?.detail)
          || data
          || i18n.global.t("toast.erreur-ajout-liste"),
      };
    });
  }

  /**
   * Ajoute une offre au panier après validation basique et vérification de disponibilité.
   * @param offre - L'offre à ajouter
   * @param quantite - La quantité à ajouter
   * @returns -
   */
  ajouterArticle(offre: Offre, quantite: number) {
    if (!quantite) {
      return Promise.resolve({
        success: false,
        message: i18n.global.t("toast.selection-quantite-superieur-a-x", { quantite }),
      });
    }
    const offreDisponible = acceptedCodes.includes(offre.code_disponibilite);

    if (!offreDisponible) {
      return Promise.resolve({
        success: false,
        message: i18n.global.t("panier.offre-non-disponible"),
      });
    }

    return this._ajouterArticle(offre, quantite);
  }
}
